/**************************************************************************
 * Created for dynamic sidebar layout variant
 ********************************************************************************/

import { useEffect, useRef, useState } from "react";
import './index.scss';
import { Outlet, useLocation } from "react-router-dom";
import { MENUPOSITION } from "../../../dashboard/model";
import SideBarUserDynamic from "../../../dashboard/side-bars/sidebar-user/SideBarUserDynamic";
import { useDssContext } from "../../../../DSSContext";
import DSSLoader from "../../../../ui/building-blocks/atoms/dss-loader/dss-loader";

export const UserLayoutSideDynamic = (): JSX.Element => {
  const { active, setActive, allowedRoutesReady } = useDssContext();
  const refreshCountsRef = useRef<() => void>(() => { });
  const outletContainerRef = useRef<HTMLElement | null>(null);
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (outletContainerRef.current) {
      outletContainerRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  const handleMenuClick = () => {
    if (active === '') setActive(' active');
    else setActive('');
    setOpenSubMenu(null);
  };

  return (
    <div className="user-container-left">
      <div className={"left-container" + active}>
        <SideBarUserDynamic
          active={active}
          onMenuClick={handleMenuClick}
          openSubMenu={openSubMenu}
          setOpenSubMenu={setOpenSubMenu}
          data-testid="sidebaruser"
          menuPosition={MENUPOSITION.VERTICAL}
          refreshCounts={refreshCountsRef}
          leftmenu={!!active}
        />
      </div>
      <main ref={outletContainerRef} className={"outlet-container" + active}>
        {!allowedRoutesReady
          ? <DSSLoader id="route-guard-loader" />
          : <Outlet context={{ refreshCounts: refreshCountsRef }} />
        }
      </main>
    </div>
  );
};

export default UserLayoutSideDynamic;
